import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  BrowserRouter,
  Route,
  Routes
} from "react-router-dom";
import './App.css';
import SiteFooter from './components/SiteFooter';
import SiteHeader from './components/SiteHeader';
import Home from "./pages/Home";
import OfferDetails from './pages/OfferDetails';
import Status from './pages/Status';

const queryClient = new QueryClient()
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <div className="min-h-screen bg-slate-50">
          <SiteHeader />
          <main>
            <Routes>
              {/* Home */}
              <Route index element={<Home />} />
              <Route path="/status/:trackingId" element={<Status />} />
              <Route path="/offers/:id" element={<OfferDetails />} />
            </Routes>
          </main>
          <SiteFooter />
        </div>

      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
